<template>
  <div>
    <BaseModal :config="docModalConfig">
      <BaseDocumentMgrandDropoff
        ref="buyoutDocumentMgr"
        :mgrGridQuery="filterCondition"
        :transactionRecord="transactionRecord"
      ></BaseDocumentMgrandDropoff>
    </BaseModal>
  </div>
</template>

<script>
import BaseDocumentMgrandDropoff from "@/components/base/BaseDocumentMgrandDropoff.vue";
import BaseModal from "@/components/base/BaseModal.vue";

export default {
  name: "BuyoutDocumentDropoffForm",
  props: {
    docModalConfig: {},
    filterCondition: {},
    transactionRecord:{}
  },
  components: {
    BaseModal,
    BaseDocumentMgrandDropoff
  },
  data: function() {
    return {
      businessEvent: "Buyout"
    };
  },
  methods: {},
  mounted() {}
};
</script>
